import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../../components/Button';
import TextField from '../../../components/TextField';
import filterIcon from './filter.svg';
import { getColorVars } from '../../../utils/functions';

interface Props {
  categories: string[];
  selectedCategories: string[];
  setSelectedCategories: (newCategories: string[]) => void;
  keywords: string;
  setKeywords: (newKeywords: string) => void;
}

function OrderHistoryFilters(props: Props): JSX.Element {
  const [showFilters, setShowFilters] = useState(false);

  const { textColor } = getColorVars();

  const { t } = useTranslation('order_history');

  function clearFilters() {
    props.setKeywords('');
    props.setSelectedCategories([]);
  }

  function categoryChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { id } = e.target;

    if (e.target.checked) {
      const newCategories = [...props.selectedCategories];
      newCategories.push(id);
      props.setSelectedCategories(newCategories);
    } else {
      const newCategories = props.selectedCategories.filter(
        (category) => category !== id
      );
      props.setSelectedCategories(newCategories);
    }
  }

  return (
    <div className='mt-4 mb-6 px-4 md:mt-28 md:px-0'>
      <div className='flex align-middle justify-between gap-4'>
        <TextField
          id='search'
          value={props.keywords}
          onChange={props.setKeywords}
          placeholder={t('Search...') ?? 'Search...'}
          className='h-12 w-full'
          icon={'bg-[url(/public/images/magnifying_glass.svg)]'}
        />
        <Button
          variant='transparent'
          className=' border-black text-black w-fit flex flex-row-reverse px-6 gap-2'
          onClick={() => setShowFilters(!showFilters)}
          icon={filterIcon}
        >
          {t('Filters')}
        </Button>
      </div>
      {showFilters && (
        <div className='border-gray-300 border-1 bg-white py-4 px-3 my-4'>
          <div className='flex justify-between'>
            <button
              className={`${textColor} cursor-pointer`}
              onClick={clearFilters}
            >
              {t('Clear filters')}
            </button>
            <button
              className={`${textColor} cursor-pointer`}
              onClick={() => setShowFilters(false)}
            >
              {t('Hide filters')}
            </button>
          </div>

          <h3 className='text-lg my-4'>{t('Categories')}</h3>

          <div className='flex flex-col gap-y-2'>
            {props.categories.map((category) => (
              <div key={category} className='flex gap-x-2'>
                <input
                  className='w-6 h-6 border border-gray-300 text-sm rounded-lg block p-2.5'
                  type='checkbox'
                  id={category}
                  name={category}
                  onChange={categoryChange}
                  checked={props.selectedCategories.includes(category)}
                />
                <label htmlFor={category}>{t(category)}</label>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default OrderHistoryFilters;
